<template>
    <header class="navbar navbar-nav navbar-expand navbar-dark navbar-theme-primary mb-2 mb-sm-6">
        <div class="container px-3 px-md-4">
            <div class="d-flex align-items-center"></div>
            <button class="btn btn-link bd-search-docs-toggle d-lg-none p-0 ms-3 order-3 ms-auto" type="button"
                    data-bs-toggle="collapse" data-bs-target="#bd-docs-nav" aria-controls="bd-docs-nav"
                    aria-expanded="false" aria-label="Toggle docs navigation">
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" role="img"><title>
                    Menu</title>
                    <path stroke="#fff" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"
                          d="M4 7h22M4 15h22M4 23h22"></path>
                </svg>
            </button>
            <div class="d-flex align-items-center">
                <ul class="flex-row list-unstyled me-3 mb-0 d-none d-lg-flex">
                    <li class="me-3">
                        <a href="https://www.facebook.com/bettertechrondonia" target="_blank">
                            <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="facebook"
                                 class="icon icon-xs text-white" role="img" xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 512 512">
                                <path fill="currentColor"
                                      d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"></path>
                            </svg>
                        </a>
                    </li>
                </ul>
                <div class="d-none d-lg-flex">
                    <a class="btn btn-secondary text-dark animate-up-2 ms-3 d-none d-sm-flex align-items-center justify-content-center"
                       href="https://www.bettertech.com.br"
                       target="_blank">
                        <svg class="icon icon-xs me-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                             xmlns="http://www.w3.org/2000/svg"
                             stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="12" cy="12" r="10"></circle>
                            <circle cx="12" cy="12" r="4"></circle>
                            <line x1="4.93" y1="4.93" x2="9.17" y2="9.17"></line>
                            <line x1="14.83" y1="14.83" x2="19.07" y2="19.07"></line>
                            <line x1="14.83" y1="9.17" x2="19.07" y2="4.93"></line>
                            <line x1="14.83" y1="9.17" x2="18.36" y2="5.64"></line>
                            <line x1="4.93" y1="19.07" x2="9.17" y2="14.83"></line>
                        </svg>
                        Atendimento</a>
                </div>
            </div>
        </div>
    </header>
    <main>
        <slot></slot>
    </main>
    <flash-messages></flash-messages>
</template>

<script>
import FlashMessages from "@/Utils/FlashMessages";

export default {
    components: {
        FlashMessages
    },
    props: {
        auth: Object,
        flash: Object,
    }
}
</script>

<style scoped>

</style>
